import BundlesRoute from '@/pages/BundlesRoute.vue'
import DonationCompleteRoute from '@/pages/DonationCompleteRoute.vue'
import DonationRoute from '@/pages/DonationRoute.vue'
import FlowDetailsRoute from '@/pages/FlowDetailsRoute.vue'
import PaymentReturnRoute from '@/pages/PaymentReturnRoute.vue'

import { useFlags } from '@/composables/useFlags'
import type { RouteDefinition } from '@/router'

export const routes: RouteDefinition[] = [
  {
    path: '/bundles',
    name: 'bundle-list',
    component: BundlesRoute,
    meta: {
      title: 'Bundles',
    },
  },
  {
    name: 'Flow Details',
    path: '/flows/:id',
    component: FlowDetailsRoute,
    beforeEnter: (to) => {
      if (useFlags().value.flows_bundles_redirect) {
        return { name: 'Bundle Details', params: to.params, query: to.query, replace: true }
      }
    },
  },
  {
    name: 'Bundle Details',
    path: '/bundles/:id',
    component: FlowDetailsRoute,
  },
  {
    path: '/donations/:id',
    name: 'donation',
    component: DonationRoute,
  },
  {
    path: '/donations/:id/complete',
    name: 'donation-complete',
    component: DonationCompleteRoute,
    meta: {
      title: 'Donation Complete',
    },
  },
  {
    path: '/payment-return',
    name: 'payment-return',
    component: PaymentReturnRoute,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFoundPage',
    component: () => import('@/pages/NotFoundPage.vue'),
  },
]
